import React from 'react';
import { UsersContainer } from './users';

const ManageUsersSection: React.FC = () => {
  return <UsersContainer />;
};

export default ManageUsersSection;